/** Parse a fuel quantity; returns null when the value was never set. */
function parseQty(value) {
  if (value === null || value === undefined || value === '') return null;
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
}

/** Delivered diesel for invoice fuel cost (0 is valid; only fall back to ordered if unset). */
export function invoiceDeliveredDiesel(job) {
  if (!job) return 0;
  const delivered = parseQty(job.delivered_diesel);
  if (delivered !== null) return delivered;
  const ordered = parseQty(job.diesel_quantity);
  return ordered !== null ? ordered : 0;
}

/** Delivered DEF for invoice fuel cost (0 is valid; never fall back to ordered). */
export function invoiceDeliveredDef(job) {
  if (!job) return 0;
  const delivered = parseQty(job.delivered_def);
  if (delivered !== null) return delivered;
  return 0;
}

/** Delivered dyed for invoice fuel cost (0 is valid; never fall back to ordered). */
export function invoiceDeliveredDyed(job) {
  if (!job) return 0;
  const delivered = parseQty(job.delivered_dyed);
  if (delivered !== null) return delivered;
  return 0;
}
